<template>
<table>
	<template v-if="adjustmentVisible">
		<tr>
			<th class="pr-3">
				Bulk Price Adjustment
				<div style="font-weight: normal;">{{ selectedMaterials.length }} materials selected</div>
			</th>
			<td style="width: 120px;">
				<field 
					:params="{type:'number',min:0,step:0.001,placeholder:'Price Adjustment'}" 
					v-model="localBulkPriceAdjustment">
				</field>
			</td>
			<td>
				<div class="d-flex align-items-center">
					<button type="button" class="btn btn-success mr-2" v-on:click="applyBulk('priceAdjustment')">Apply</button>
					<i class="fa fa-times icon-button" v-on:click="adjustmentVisible = false"></i>
				</div>
			</td>
		</tr>
		<tr>
			<td></td>
			<td colspan="2" class="text-muted">Bulk price adjustment factor (ex. enter 1.2 for a 20% increase)</td>
		</tr>
	</template>
	<template v-if="markupVisible">
		<tr>
			<th class="pr-3">
				Bulk Markup
				<div style="font-weight: normal;">{{ selectedMaterials.length }} materials selected</div>
			</th>
			<td style="width: 120px;">
				<field 
					:params="{type:'number',min:0,step:0.001,placeholder:'Markup'}" 
					v-model="localBulkMarkup">
				</field>
			</td>
			<td>
				<div class="d-flex align-items-center">
					<button type="button" class="btn btn-success mr-2" v-on:click="applyBulk('markup')">Apply</button>
					<i class="fa fa-times icon-button" v-on:click="markupVisible = false"></i>
				</div>
			</td>
		</tr>
		<tr>
			<td></td>
			<td colspan="2" class="text-muted">Bulk markup factor (ex. enter 1.2 for a 20% markup)</td>
		</tr>
		<tr v-if="clientInvoiceSettings.summaryMarkup == 1">
			<th class="pr-3"></th>
			<td colspan="2" class="text-muted">
				Markup is set to be managed equally for all materials
			</td>
		</tr>
	</template>
	
	<tr>
		<td colspan="3">
			<button v-if="selectedMaterials.length > 0" type="button" class="btn btn-outline-danger btn-sm mr-1" v-on:click="removeSelected">
				<i class="fa fa-trash"></i>
				Remove
			</button>
			<button v-if="!markupVisible" type="button" class="btn btn-primary btn-sm mr-1" v-on:click="markupVisible = true">
				Bulk Markup
			</button>
			<button v-if="!adjustmentVisible" type="button" class="btn btn-primary btn-sm" v-on:click="adjustmentVisible = true">
				Bulk Price Adjustment
			</button>
		</td>
	</tr>
</table>
</template>
<script type="text/javascript">
import Field from "@/components/Field"

export default {
	components: {
		Field
	},
	props: [
		"bulkMarkup",
		"bulkPriceAdjustment",
		"clientInvoiceSettings",
		"selectedMaterials",
		"allMaterials",
		"invoiceId",
		"model"
	],
	data() {
		return {
			localBulkMarkup: null,
			localBulkPriceAdjustment: null,
			markupVisible: false,
			adjustmentVisible: false
		}
	},
	watch: {
		bulkMarkup() {
			this.localBulkMarkup = this.bulkMarkup
		},
		bulkPriceAdjustment() {
			this.localBulkPriceAdjustment = this.bulkPriceAdjustment
		}
	},
	methods: {
		removeSelected() {
			this.$emit("removeSelected")
		},
		applyBulk(value) {

			let vm = this

			let materialsToApply = this.selectedMaterials

			if (value == 'markup' && this.clientInvoiceSettings.summaryMarkup == 1)
				materialsToApply = this.allMaterials

			let recordSet = materialsToApply.map(mat => {
				let fields = JSON.parse(JSON.stringify(mat))

				delete fields.invoice_id

				if (value == "markup")
					fields[value] = vm.localBulkMarkup
				else if (value == "priceAdjustment")
					fields[value] = vm.localBulkPriceAdjustment

				let object = {
					id: fields.id,
					type: "Material",
					field_values_json: JSON.stringify(fields)
				}

				if (vm.model == 'ServiceInvoiceObject')
					object.invoice_id =  vm.invoiceId
				else if (vm.model == 'JobChangeOrderObject')
					object.quote_id = vm.invoiceId

				return object
			})

			this.postData(this.model+"/save-batch",{records: recordSet}).then(response => {
				vm.$emit("bulkApplied")
				vm.$emit("autoDeselect")
			})
		}
	}
}
</script>